<template>
  <Tabs />
  <BudgetSheets
    kind_of="est"
  />
</template>

<script>
import BudgetSheets from './BudgetSheets'
import Tabs from './Tabs'
export default {
  name: "BudgetSheetPlan",
  components: { BudgetSheets, Tabs },
}
</script>